(function () {
    'use strict';

    angular
        .module('app.eventDisplay')
        .controller('EventDisplayDetailsController', EventDisplayDetailsController);

    EventDisplayDetailsController.$inject = [
        '$state', '$stateParams', '$window',
        'bootstrap.dialog', 'common', 'dataservice', '$interval', '$sce'
    ];

    function EventDisplayDetailsController($state, $stateParams, $window, bsDialog, common, dataservice, $interval, $sce) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
       

        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.currentDate = new Date();
        vm.fonts = [];
        vm.promoImages = [];
        vm.getLogo = getLogo;
        vm.getImage = getImage;
        vm.hasLogo = hasLogo;
        vm.bookings = [];
        vm.displayTypeChanged = displayTypeChanged;
        vm.opsIncludeVersion = common.opsIncludeVersion;
        vm.showBuildings = false;
        

        vm.viewChanged = viewChanged;
        vm.roomViewLabel = 'View';
        vm.isLoading = true;
        vm.isRoomCard = isRoomCard;
        vm.isEventDisplay = isEventDisplay;
        vm.isPictureBox = isPictureBox;
        vm.setBorderColors = setBorderColors;
        vm.roomInUse = true;
        vm.roomName = "";
        vm.setRoomName = setRoomName;
        vm.managers = [];
        
        vm.logo = {};

        vm.mainboxStyle = mainboxStyle;
        vm.pictureBoxStyle = pictureBoxStyle;
        vm.getPictureBoxContent = getPictureBoxContent;

        vm.eventTypeLabel = "Event Types";

        vm.buildingsLabel = "Views";


        activate();

        function activate() {
            var promises = [initLookups(), getItem(), getLicenseInfo()];

            return common.$q.all(promises).then(function (data) {
                setDisplayForApiType();
                $interval(timerTick, 1000);
                var start = new Date();
                var end = new Date();
                start.setHours(15);
                end.setHours(16);

                vm.bookings.push({
                    BookingId: 1,
                    EventStartUtc: start,
                    EventEndUtc: end,
                    EventName: "Good Old Fashioned Fun",
                    Group: "The Village People",
                    Room: "Main Lobby"
                });
                vm.bookings.push({
                    BookingId: 2,
                    EventStartUtc: start,
                    EventEndUtc: end,
                    EventName: "Masterpieces in Literature",
                    Group: "English Club",
                    Room: "Amphitheater"
                });
                vm.setRoomName();
                vm.isLoading = false;
            }, function (error) { });
        }

        function setDisplayForApiType() {
            if (common.userService.apiTypeId() === common.config.apiTypes.collegeNet) {
                vm.eventTypeLabel = "Event Categories";
                vm.buildingsLabel = "Location Categories";
            }
            else {
                setBuildingViews();
                
            }
        }

        function setBuildingViews() {
            if (common.userService.apiTypeId() === common.config.apiTypes.ems) {
                if (common.userService.tenantId() == "222" || common.userService.tenantId() == 265) {
                //if (common.userService.tenantId() == "25") {

                    if (vm.item.DisplayTypeUId !== common.config.displayTypes.eventDisplay) {
                        vm.buildingsLabel = "Buildings";
                        vm.showBuildings = true;
                    }
                    else {
                        vm.buildingsLabel = "Views";
                        vm.showBuildings = false;
                    }
                }

            }
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                if (vm.licenseInfo.NumberOfDisplaysLicensed < vm.licenseInfo.NumberOfDisplaysInUse) {
                    $state.go('404');
                }
                
            }, function (error) { });
        }

        function isRoomCard() {
            if (vm.item) {
                return vm.item.DisplayTypeUId === common.config.displayTypes.roomCard;
            }
            return false;
        }

        function isEventDisplay() {
            if (vm.item) {
                return vm.item.DisplayTypeUId === common.config.displayTypes.eventDisplay;
            }
            return false;
        }

        function isPictureBox() {
            if (vm.item) {
                return vm.item.DisplayTypeUId === common.config.displayTypes.pictureBox;
            }
            return false;
        }

        function setRoomName() {
            vm.roomName = "";
            if (vm.item && vm.rooms) {
                for (var i = 0; i < vm.rooms.length; i++) {
                    if (vm.rooms[i].ID == vm.item.RoomId) {
                        vm.roomName = vm.rooms[i].Description;
                        break;
                    }
                }
            }

        }

        function timerTick() {
            vm.currentDate = new Date();
        }

        function setBorderColors() {
            if (isRoomCard()) { //room card
                vm.item.AvailableBorderColor = vm.item.BodyBackgroundColor;
                vm.item.InUseBorderColor = vm.item.BodyBackgroundColor;
            }
        }

        function displayTypeChanged() {
            if (isRoomCard()) { //room card
                vm.item.TimeWidth = 250;
                vm.item.EventWidth = 500;
                vm.item.GroupWidth = 500;
                vm.item.RoomWidth = 500;
                vm.item.DisplayRoom = 0;
                vm.item.InUseBorderColor = "#ff0000";
                vm.item.InUseTextColor = "#ffffff";
                vm.item.AvailableTextColor = "#ffffff";
                vm.item.InUseText = "ROOM IN USE";
                vm.item.AvailableText = "ROOM AVAILABLE";
                vm.item.AvailableBorderColor = "#008000";
                vm.item.StartsWithinXHours = 0;
                vm.item.DropEventsAfterXMinutes = 0;

            }
            else {
                setBuildingViews();
                vm.item.RoomId = "";
                vm.item.TimeWidth = 200;
                vm.item.EventWidth = 400;
                vm.item.GroupWidth = 400;
                vm.item.RoomWidth = 400;
                vm.item.DisplayRoom = 1;
                vm.item.InUseText = "";
                vm.item.AvailableText = "";
               
                vm.item.InUseBorderColor = vm.item.BodyBackgroundColor;
                vm.item.AvailableBorderColor = vm.item.BodyBackgroundColor;
                vm.item.StartsWithinXHours = 0;
                vm.item.DropEventsAfterXMinutes = 0;
            }

        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("eventdisplay.list");
        }

       

        function viewChanged() {
            if (vm.item.ViewId !== '') {
                dataservice.getItems("api/EventDisplay/RoomsInView/" + vm.item.ViewId).then(function (response) {
                    vm.rooms = response.data;
                }, function (error) { console.log(error) });
            }
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Event Display')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/EventDisplay/" + vm.item.Id).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function hasLogo() {
            return (vm.item && (vm.item.LogoId !== '' && vm.item.LogoId !== null && vm.item.LogoId !== '00000000-0000-0000-0000-000000000000'));
        }

        function getLogo() {
            if (hasLogo()) {
                var dto = {
                    PromotionalImageId: vm.item.LogoId,
                    Height: 200,
                    Width: 200
                };
                dataservice.query("api/PromotionalImages/GetThumbnail", dto).then(function (response) {
                    vm.logo.Base64Data = response.data.Base64Data;
                }, function (error) { });
            }
            else {
                vm.logoPreview = "";
            }
        }

        function getImage(propName, imageModel, height, width) {
            
            if (vm.item && (vm.item[propName] !== '' && vm.item[propName] !== null && vm.item[propName] !== '00000000-0000-0000-0000-000000000000')) {
                var dto = {
                    PromotionalImageId: vm.item[propName],
                    Height: height, //tell it full size
                    Width: width
                };
                dataservice.query("api/PromotionalImages/GetThumbnail", dto).then(function (response) {
                    vm.item[imageModel].Base64Data = response.data.Base64Data;
                }, function (error) { });
            }
            else {
                vm.item[imageModel] = {};
            }
        }


        function getItem() {
            var val = $stateParams.id;
            if (val === '' && common.userService.userType() === "1") {
                $state.go('404');
            }
            if (val === '') {
                vm.item = {};
                vm.item.NumberOfEventsPerPage = 5;
                vm.item.DataRefreshInterval = 5;
                vm.item.PageTransitionInterval = 5;
                vm.item.EventLabel = "EVENT";
                vm.item.RoomLabel = "ROOM";
                vm.item.GroupLabel = "GROUP";
                vm.item.Font = "Arial, Helvetica, sans-serif";
                vm.item.DisplayRoom = 1;
                vm.item.DisplayGroup = 1;
                vm.item.DisplayEvent = 1;
                vm.item.HeaderTextSize = 20;
                vm.item.ColumnHeaderTextSize = 18;
                vm.item.TableTextSize = 16;
                vm.item.TableTextSize = 16;
                vm.item.TimeWidth = 200;
                vm.item.EventWidth = 400;
                vm.item.GroupWidth = 400;
                vm.item.RoomWidth = 400;
                vm.item.BodyBackgroundColor = '#343E47';
                vm.item.HeaderTextColor = '#FFFFFF';
                vm.item.TableHeaderBackgroundColor = '#343E47';
                vm.item.TableHeaderTextColor = '#d1e1f5';
                vm.item.TableBodyTextColor = '#d1e1f5';
                vm.item.TableRowBackgroundColor = '#3a3f50';
                vm.item.TableAltRowBackgroundColor = '#2f353e';
                vm.item.InUseBorderColor = '#343E47';
                vm.item.AvailableBorderColor = '#343E47';
                vm.item.StartsWithinXHours = 0;
                vm.item.DropEventsAfterXMinutes = 0;
                vm.item.StatusIdArray = [];
                vm.item.EventTypeIdArray = [];
                vm.item.UsersWithConfigAccess = [];
                vm.item.PromotionalImages = [];
                vm.item.HonorEventTypeDOW = 0;
                vm.item.DisplayTypeUId = common.config.displayTypes.eventDisplay;
                vm.item.MainBackgroundImage = {};
                vm.item.PictureBackgroundImage = {};
                vm.item.RepeatPictureBackgroundImage = 1;
                vm.item.RepeatMainBackgroundImage = 1;
                vm.item.TopRowHeight = 50;
                vm.item.BottomRowHeight = 50;
                vm.item.MainContentWidth = 90;
                vm.item.PicutreBoxMainBackgroundColor = '#343E47';
                vm.item.PicutreBoxBackgroundColor = '#FFFFFF';
                vm.item.InProgressStartOnReservedTime = 1;
                vm.item.InProgressEndOnReservedTime = 0;
                vm.item.PictureTopLeftContent = '';
                vm.item.PictureTopRightContent = '';

                common.setAuditInfo(vm.item);
                return vm.item;
            }

            return dataservice.getItem("api/EventDisplay/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                        vm.item.MainBackgroundImage = {};
                        vm.item.PictureBackgroundImage = {};
                        if (!vm.item.StatusIdArray) {
                            vm.item.StatusIdArray = [];
                        }
                        if (!vm.item.EventTypeIdArray) {
                            vm.item.EventTypeIdArray = [];
                        }
                        if (!vm.item.UsersWithConfigAccess) {
                            vm.item.UsersWithConfigAccess = [];
                        }
                        viewChanged();
                        getLogo();

                        if (vm.item.MainBackgroundImageId !== '00000000-0000-0000-0000-000000000000') {
                            getImage('MainBackgroundImageId', 'MainBackgroundImage', -1, -1);
                        }
                        if (vm.item.PictureBackgroundImageId !== '00000000-0000-0000-0000-000000000000') {
                            getImage('PictureBackgroundImageId', 'PictureBackgroundImage', -1, -1);
                        }
                        
                        common.setAuditInfo(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function initLookups() {
            dataservice.getItems("api/EventDisplay/GetLookups").then(function (response) {
                vm.statuses = response.data.Statuses;
                vm.eventTypes = response.data.EventTypes;
                vm.views = response.data.Views;
                vm.promoImages = response.data.PromotionalImages;
                vm.displayTypes = response.data.DisplayTypes;
                vm.buildings = response.data.Buildings;
                vm.managers = response.data.Managers;

                vm.fonts.push("Georgia, serif");
                vm.fonts.push('"Palatino Linotype", "Book Antiqua", Palatino, serif');
                vm.fonts.push('"Times New Roman", Times, serif');
                vm.fonts.push('Arial, Helvetica, sans-serif');
                vm.fonts.push('"Arial Black", Gadget, sans-serif');
                vm.fonts.push('"Comic Sans MS", cursive, sans-serif');
                vm.fonts.push('Impact, Charcoal, sans-serif');
                vm.fonts.push('"Lucida Sans Unicode", "Lucida Grande", sans-serif');
                vm.fonts.push('Tahoma, Geneva, sans-serif');
                vm.fonts.push('"Trebuchet MS", Helvetica, sans-serif');
                vm.fonts.push('Verdana, Geneva, sans-serif');
                vm.fonts.push('"Courier New", Courier, monospace');
                vm.fonts.push('"Lucida Console", Monaco, monospace');
                vm.fonts.push("Futura Bold");
                vm.fonts.push("Avenir");
                vm.fonts.push("Source Sans Pro");
                vm.fonts.sort();
           
            }, function (error) { console.log(error) });

         
        }

        function save() {
            if (vm.item.StatusIdArray.length === 0) {
                common.logger.error("You must select at least one status");
                return;
            }
            if (vm.item.EventTypeIdArray.length === 0 && common.userService.apiTypeId() !== common.config.apiTypes.collegeNet) {
                common.logger.error("You must select at least one event type");
                return;
            }

            vm.isSaving = true;
            vm.item.MainBackgroundImage = "";
            
            dataservice.saveItem('api/EventDisplay', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
            
        }


        function mainboxStyle() {
            
            var result = {};
            result.width = "100%";
            result.height = "100%";
            if (vm.item && vm.item.MainBackgroundImage && vm.item.MainBackgroundImage.Base64Data) {
                result["background"] = "url(data:image/png;base64," + vm.item.MainBackgroundImage.Base64Data + ")";
                if (vm.item.RepeatMainBackgroundImage == 0) {
                    result["background"] += "no-repeat";
                }
            }
            else {
                result["background-color"] = vm.item.PicutreBoxMainBackgroundColor;
            }

            return result;
        }


        function pictureBoxStyle() {

            var result = {};
            if (vm.item && vm.item.PictureBackgroundImage && vm.item.PictureBackgroundImage.Base64Data) {
                result["background"] = "url(data:image/png;base64," + vm.item.PictureBackgroundImage.Base64Data + ")";
                if (vm.item.RepeatPictureBackgroundImage == 0) {
                    result["background"] += "no-repeat";
                }
            }
            else {
                result["background-color"] = vm.item.PicutreBoxBackgroundColor;
            }


            return result;
        }

        function getPictureBoxContent(contentLocation) {
            var result = "";
            if (!vm.roomName) {
                vm.setRoomName();
            }

            if (vm.roomInUse) {
                if (contentLocation === 'Top') {
                    result = vm.item.InprogressTopContent;
                }
                else if (contentLocation === 'Main') {
                    result = vm.item.InprogressMainContent;
                }
                else {
                    result = vm.item.InprogressBottomContent;
                }
            }
            else {
                if (contentLocation === 'Top') {
                    result = vm.item.InprogressTopContent;
                }
                else if (contentLocation === 'Main') {
                    result = vm.item.AvailableMainContent;
                }
                else {
                    result = vm.item.InprogressBottomContent;
                }
            }

            if (!result) {
                result = "";
            }

            result = result.replace('%DateTime%', moment(vm.currentDate).format("LL") + "<br />" + moment(vm.currentDate).format("LTS"));
            result = result.replace('%Date%', moment(vm.currentDate).format("LL"));
            result = result.replace('%Time%', moment(vm.currentDate).format("LTS"));

            result = result.replace('%RoomName%', vm.roomName);
            //result = result.replace('%EventName%', vm.EventName);
           // result = result.replace('%RoomName%', "");
           

            return $sce.trustAsHtml(result);
            
            
        }
  
    }
})();
